// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "../../Social.telemetry";

export interface ProfilePrivacyTelemetryObjects {
    privateSwitchTurnOff: TelemetryObjectBase;
    privateSwitchTurnOn: TelemetryObjectBase;
    manageYourDataBtn: TelemetryObjectBase;
}

export const profilePrivacyTelemetryContracts = {
    /** Scenario 2a click on turnoff
     *  id: traceId
    */
    privateSwitchTurnOff: {
        name: "PrivacySwitch",
        behavior: TelemetryBehaviorType.TurnOff,
        content: {
            headline: "Turn Off",
            type: TelemetryContentType.Profile
        }
    },
    /** Scenario 2b click on turnon
     * id: traceId
    */
    privateSwitchTurnOn: {
        name: "PrivacySwitch",
        behavior: TelemetryBehaviorType.TurnOn,
        content: {
            headline: "Turn On",
            type: TelemetryContentType.Profile
        }
    },
    /** Scenario 3 click on turnon
     * id: traceId
    */
    manageYourDataBtn: {
        name: "ManageYourData",
        behavior: TelemetryBehaviorType.Open,
        content: {
            headline: "Continue",
            type: TelemetryContentType.Profile
        }
    }
};

export const profilePrivacyTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    genericClicked: genericTelemetryClickDispatcher
};